import { ProvenanceBadge } from "./Primitives.web";
import type { PanchangTiming } from "./types";

export function PanchangTimeStrip({
  timings,
  title = "Today’s panchang timings",
  titleId = "panchang-timing-title",
}: {
  timings: readonly PanchangTiming[];
  title?: string;
  titleId?: string;
}) {
  return (
    <section className="jyotish-panchang" aria-labelledby={titleId}>
      <header>
        <h3 id={titleId}>{title}</h3>
        <ProvenanceBadge kind="engine" label="Location-aware calculation" />
      </header>
      <dl>
        {timings.map((timing) => (
          <div key={timing.id} data-tone={timing.tone ?? "neutral"}>
            <dt>{timing.label}</dt>
            <dd>{timing.value}</dd>
          </div>
        ))}
      </dl>
    </section>
  );
}

export default PanchangTimeStrip;
